import { createStore } from 'redux'
import reducer from './reducer'

export function createMundialStore () {
  return createStore(reducer)
}


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/store/index.js